import { domain } from 'config/system';
import { cx } from 'emotion';
import React, { FC, useState } from 'react';
import { SimpleImg } from 'react-simple-img';
import * as styles from './styles';

const resolveURL = (url: string) =>
  url.startsWith('/asset') ? `${domain.image}${url}` : url;

interface InnerImageProps extends Omit<ImageProps, 'lazyload'> {}

export interface ImageProps {
  className?: string;
  src: string;
  lazyload?: boolean;
}

const InnerImage: FC<InnerImageProps> = ({ className, src }) => {
  const [loaded, setLoaded] = useState(false);

  const onLoad = () => {
    setLoaded(true);
  };

  return (
    <img
      className={className}
      src={src}
      style={{ opacity: loaded ? 1 : 0 }}
      onLoad={onLoad}
      alt=""
    />
  );
};

/**
 * An once lazyload Image component.
 * If `src` has prefix `/asset`, it will be added image domain of storage bucket or cdn url on.
 */
const Image: FC<ImageProps> = ({ className, src, lazyload }) => {
  if (!src) {
    return null;
  }
  return lazyload ? (
    <SimpleImg
      className={cx(styles.image, className)}
      src={resolveURL(src)}
      placeholder={false}
    />
  ) : (
    <InnerImage className={cx(styles.image, className)} src={resolveURL(src)} />
  );
};

export default Image;
